import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          text: "Play sound",
          icon: "cis-volume-high",
          theme: "secondary",
          size: "xlarge",
          shape: "round",
          url: `${config.ASSETS_URL}/02/18/principle/74-dB-noise.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          text: "Play sound",
          icon: "cis-volume-high",
          theme: "secondary",
          size: "xlarge",
          shape: "round",
          url: `${config.ASSETS_URL}/02/18/principle/30-dB.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          text: "Play sound",
          icon: "cis-volume-high",
          theme: "secondary",
          size: "xlarge",
          shape: "round",
          url: `${config.ASSETS_URL}/02/18/principle/74-dB-noise-without-inclusion-of-noise.wav`,
        },
      },
    },
  },
];

export default components;
